import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {FETCH_MFA_SCAN_BAR_URL, FIRST_TIME_CHANGE_PASSWORD_URL, LOGIN_URL} from '../config/url-config'

import {ERR_MSG, SESS_EXPIRED_TEXT, SUCCESS_CODES,
    FETCH_MFA_SCAN_BAR_ERR_100,
    FETCH_MFA_SCAN_BAR_ERR_101,
   } from "../constants/constants";
import {store} from "../store/store";
import {loadSessionExpired} from "../store/action";
import {extractStatusCode} from "../helper/responsehelper";

export const scanBarResponseStatus = {
    [FETCH_MFA_SCAN_BAR_ERR_100]:SESS_EXPIRED_TEXT,
    [FETCH_MFA_SCAN_BAR_ERR_101]:ERR_MSG,
    "UNK-ERR-102": ERR_MSG,
};
const constructFetchScanBar = (session)=>(
    {
        session:session,
    }
)
export const fetchMFAScanBarService = (session)=>{
    const scanBarRequest = constructFetchScanBar(session)
    return new Promise((resolve,reject)=>{
        axiosInstance
            .post(FETCH_MFA_SCAN_BAR_URL(),scanBarRequest)
            .then((response) => {

                let statusCode =extractStatusCode(response);
                if(SUCCESS_CODES.FETCH_MFA_SCAN_BAR.includes(statusCode)){
                    resolve(response)
                }else{
                    let errText = scanBarResponseStatus[statusCode]
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                reject(ERR_MSG)
            });
    })
}